import { AudioPlayer } from "../ui/components";
import { debounce } from "../utils/debounce";
import { throttle } from "../utils/throttle";

export class TextPlayer extends AudioPlayer {
    ATTRS = {
        START_TIME: 'data-start-time',
    }

    text_transcribers = {};

    init() {
        super.init();

        this.textTranscribe = this.parent.text_transcriber.element;
        this.currentTabId = "0";

        this.text_transcribers[this.currentTabId] = {
            words: this.getTrinscribeWords(),
            parent: this.textTranscribe,
        };

        this.currentWords = this.text_transcribers[this.currentTabId].words;
        this.totalWords = this.currentWords.length;

        this.setStartStates();
        this.textTranscribe.addEventListener('click', this.selectWordByClick.bind(this));

        this.onChangeProgress = throttle((time) => this.updateByTime(time), 16);

        window.addEventListener('tabChange', this.handleTabChange.bind(this));
    }

    getTrinscribeWords(parent) {
        return (parent || this.textTranscribe).querySelectorAll('[' + this.ATTRS.START_TIME + ']');
    }

    /**
     * 
     * @param {Object} param0 - параметры от кастомного эвента
     * @param {Object} param0.detail - дополнительные даные об активном табе
     * @param {string|number} param0.detail.id - индентификатор таба/транскрибации
     * @param {HTMLElement} param0.detail.text_transcribe - ссылка на dom элемент с текстом транскрибации
     * 
     */
    handleTabChange({ detail }) {
        this.resetAudioplayer();

        if (!this.text_transcribers[detail.id]) {
            const textTranscribe = this.parent.find(`[data-tab-content="${detail.id}"] .text_transcriber`);

            this.text_transcribers[detail.id] = {
                words: this.getTrinscribeWords(textTranscribe),
                parent: textTranscribe,
            };
            textTranscribe.addEventListener('click', this.selectWordByClick.bind(this));
        }

        this.currentWords = this.text_transcribers[detail.id].words;
        this.textTranscribe = this.text_transcribers[detail.id].parent;
        this.totalWords = this.currentWords.length;

        this.setStartStates();
    }

    scrollToWord(el) {
        if (!el) return;

        el.scrollIntoView({ block: 'center' });
    }

    resetAudioplayer() {
        this.pause();
        this.changeCurrentTime(0);
        this.resetprogressBar();
    }

    updateWords() {
        this.resetAudioplayer();
        this.currentWords = this.getTrinscribeWords();
        this.totalWords = this.currentWords.length;
        this.setStartStates();
    }

    selectWordByClick(ev) {
        if (!ev.target.hasAttribute(this.ATTRS.START_TIME)) return;

        const time = this.getWordTime(ev.target);

        this.clearBGColor(this.currWord);
        this.changeProgressByTime(time / 1000);
        this.changeCurrentTime(time / 1000);
        this.selectWordByTime(time);
    }

    setStartStates() {
        this.clearBGColor(this.currWord);

        this.currWord = null;
        this.currWordKey = 0;
        this.nextWord = this.currentWords[0];
        this.nextTime = this.getWordTime(this.nextWord);
    }

    setBGColor(el) {
        if (!el) return;

        el.classList.add("active");
    }

    clearBGColor(el) {
        if (!el) return;

        el.classList.remove("active");
    }


    getWordTime(el) {
        if (!el) return null;

        return +el.getAttribute(this.ATTRS.START_TIME);
    }

    getWordByTime(time) {
        let left = 0;
        let right = this.currentWords.length - 1;

        while (left <= right) {
            const mid = Math.floor((left + right) / 2);
            const midTime = this.getWordTime(this.currentWords[mid]);
            const nextEl = this.currentWords[mid + 1] ?? this.currentWords[mid];
            const nextTime = this.getWordTime(nextEl);

            if (midTime <= time && nextTime > time) {
                return { el: this.currentWords[mid], key: mid, nextEl: nextEl, nextTime: nextTime };
            } else if (midTime === nextTime) {
                return { el: this.currentWords[mid], key: mid, nextEl: nextEl, nextTime: nextTime };
            }

            if (midTime < time) {
                left = mid + 1;
            } else {
                right = mid - 1;
            }
        }

        return null;
    }

    isEndWord() {
        return this.currWordKey === this.totalWords;
    }

    selectWordByTime(time) {
        const wordObj = this.getWordByTime(time);
        if (!wordObj) {
            return;
        };

        this.clearBGColor(this.currWord);
        this.currWord = wordObj?.el;
        this.currWordKey = wordObj.key;
        this.nextWord = wordObj.nextEl;
        this.nextTime = wordObj.nextTime;

        debounce(200, () => { this.setBGColor(this.currWord); }, 200);
    }

    updateStatesByTime(time) {
        if (this.totalWords === 0) return;

        time === 0 ? this.setStartStates() : this.selectWordByTime(time);
    }

    onProgress(time) {
        if (this.isEndWord()) return;

        if (time >= this.nextTime) {
            this.clearBGColor(this.currWord);
            this.setBGColor(this.nextWord);
            this.currWord = this.nextWord;
            this.currWordKey = this.currWordKey + 1;

            if (this.isEndWord()) return;

            this.nextWord = this.currentWords[this.currWordKey];
            this.nextTime = this.getWordTime(this.nextWord);
        }
    }

    updateByTime(time) {
        this.updateStatesByTime(time);
        this.scrollToWord(this.currWord ?? this.nextWord);
    }

    onRewinded(time) {
        this.updateByTime(time);
    }

    onEnded() {
        this.clearBGColor(this.currWord);
        this.setStartStates();
    }
}
